import Dexie from 'dexie';
var database = new Dexie('torn-log-viewer');
import runMigrations from './migrations.js';
runMigrations(database);


export default database;